(ns minorodata.connections.sources.shopify
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "shopify"
   :enabled      false
   :name         "shopify (Deprecated)"
   :description  "The best ecommerce platform that has everything you need to sell online"
   :image-source "shopify.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                  (let [{:keys [name description username password shop-url]} data]
                       {:source-type "shopify"
                        :name        name
                        :description description

                        :source
                                     {:credentials         {:username  username
                                                            :password  password
                                                            :shop-url  shop-url}}}))

    :format-for-inputs
              (fn [data]
                  (let [{:keys [source name description]} data
                        {:keys [credentials]} source]
                       (merge
                         (select-keys credentials [:username :password :shop-url])
                         {:name              name
                          :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :shopify-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Admin API Key"
              :required   true
              :name       :username
              :value      ""}
             {:block-type :input
              :label      "Admin API Password"
              :required   true
              :name       :password
              :type       :password
              :value      ""}

             {:block-type :input
              :label      "Shop Name"
              :required   true
              :name       :shop-url
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report order-id]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :order-id          order-id
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :order-id :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :shopify-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Endpoint Service"
              :name       :report
              :options    [{:name "Orders"          :value "orders"}
                           {:name "Transactions"    :value "transactions"}
                           {:name "Products"        :value "products"}
                           {:name "Customers"       :value "customers"}]
              :required   true
              :value      "orders"}

             {:block-type :input
              :label      "Order ID"
              :name       :order-id
              :conditions [[:eq [:report :value] "transactions"]]}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})

